import template from './globalMessageList.html';
import controller from './globalMessageList.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
};

export default component;
